import { noticeFailure, noticeSuccess } from "@self/notices";
import { makeStylesheetLink } from "@self/stylesheet";

export class ApplyCoupon extends HTMLElement {

	shadow: ShadowRoot;

	input: HTMLInputElement;
	button: HTMLButtonElement;

	static get observedAttributes() {
		return ["value"] as const;
	}

	onClick: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.button = (
			<button type="button" className="gct-btn-lg gct-btn-secondary">
				Apply
			</button>
		) as HTMLButtonElement;

		this.onClick = onClick.bind(this);

		this.input = <input
			type="text"
			className="gct-w100"
			value={this.getAttribute("value") ?? ""}
			placehodler="Enter discount code"
		/> as HTMLInputElement;

		this.shadow.append(
			<div className="gct-flex-row gct-gap-16 gct-flex-space-between">
				{this.input}
				{this.button}
			</div>,
			makeStylesheetLink(),
		);
	}

	connectedCallback() {
		this.button.addEventListener("click", this.onClick);
	}

	disconnectedCallback() {
		this.button.removeEventListener("click", this.onClick);
	}
}

async function onClick(this: ApplyCoupon) {
	try {
		this.button.disabled = true;
		this.input.disabled = true;

		const couponCode = this.input.value;

		const data = new URLSearchParams({
			apply_coupon: "Apply coupon",
			coupon_code: couponCode,
			"woocommerce-cart-nonce": this.dataset.nonce!,
		});

		const res = await fetch(this.dataset.endpoint!, {
			method: "POST",
			body: data,
			credentials: "include",
		});

		const html = await res.text();
		const newDocument = new DOMParser().parseFromString(html, "text/html");
		document.body.innerHTML = newDocument.body.innerHTML;

		noticeSuccess("Coupon applied.");
	} catch (error) {
		if (error instanceof TypeError) {
			noticeFailure("Couldn't connect. Are you online?");
		} else {
			noticeFailure("There was an unexpected error.")
		}
	} finally {
		this.button.disabled = false;
		this.input.disabled = false;
	}
}

